import type { FC } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { AppBar, Link, Toolbar } from '@mui/material';
import Logo from 'src/components/Logo';
import { PATH_DASHBOARD } from 'src/routes/paths';

const MainNavbar: FC = () => (
  <AppBar
    sx={{
      background: (theme) =>
        `url(/static/islamic-pattern.png) ${theme.palette.primary.main}`,
      height: 82,
      flexDirection: 'row',
    }}
  >
    <Toolbar sx={{ padding: '8px 16px' }}>
      <Link
        sx={{ height: '100%' }}
        component={RouterLink}
        to={PATH_DASHBOARD.overview}
      >
        <Logo
          sx={{
            height: '100%',
            width: 170,
          }}
        />
      </Link>
    </Toolbar>
  </AppBar>
);

export default MainNavbar;
